<template>
  <div>
    <v-card class="pa-4">
      <div class="d-flex justify-start align-center mb-2 ml-2">
        <div class="mr-2 font-bold">Sub total:</div>
        <div>{{ saleInvoice.subTotal }}</div>
      </div>
      <div class="d-flex justify-start align-center mb-2 ml-2">
        <div class="mr-2 font-bold">Vat:</div>
        <div>{{ saleInvoice.vat }}</div>
      </div>
      <div class="d-flex justify-start align-center mb-2 ml-2">
        <div class="mr-2 font-bold">Discount:</div>
        <div>{{ saleInvoice.discount }}</div>
      </div>
      <div class="d-flex justify-start align-center mb-2 ml-2">
        <div class="mr-2 font-bold">Shipping Fee:</div>
        <div>{{ saleInvoice.shippingFee }}</div>
      </div>
      <div class="d-flex justify-start align-center mb-2 ml-2">
        <div class="mr-2 font-bold">Paid:</div>
        <div>{{ saleInvoice.paid }}</div>
      </div>
      <div class="d-flex justify-start align-center mb-2 ml-2">
        <div class="mr-2 font-bold">Currenct:</div>
        <div>{{ saleInvoice.currency }}</div>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["id"],
  mounted() {
    this.$store.dispatch("finance/LOAD_SALES_INVOICE", this.id);
  },
  computed: {
    ...mapState({
      saleInvoice: state => state.finance.saleInvoice
    })
  }
};
</script>
